import React from "react";
import Image, { ImageProps } from "next/image";
import Box, { BoxProps } from "@mui/material/Box";

import styles from "./styles/RoundImage.module.css";

const RoundImage: React.FC<{
  boxProps: BoxProps;
  imageProps: Omit<ImageProps, "src" | "alt">;
  src: string;
  alt: string;
}> = ({ boxProps, imageProps, src, alt }) => {
  return (
    <Box
      {...boxProps}
      sx={{
        background: "#ffffff",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        borderRadius: "50%",
        boxShadow: "0px 2px 4px #dde6ed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...(boxProps?.sx || {}),
      }}
    >
      <Image
        className={styles.roundImage}
        src={src}
        alt={alt}
        {...imageProps}
      />
    </Box>
  );
};

export default RoundImage;
